/*
 * @Descripttion:
 * @version:
 * @Author: yanghui
 * @Date: 2021-11-10 09:09:25
 * @LastEditors: yanghui
 * @LastEditTime: 2022-07-25 13:43:47
 */
import axios from "axios";
import { Message } from "element-ui";
import store from "../store/index";
import { BASE_URL } from "../config/app";  //正式
//var BASE_URL = "http://192.168.1.138:8088/";  //红才本地
//var BASE_URL = "http://192.168.1.237:18088/";  //本地
//var BASE_URL = "http://49.233.136.163:18080/";  //测试
//var BASE_URL = "http://www.hfmphe.net/huofuman";  //正式
//import router from "../router/index";
const BSL=process.env.VUE_APP_API_BASE;

// 创建axios实例
const service = axios.create({
    baseURL: BASE_URL,
    timeout: 300000
});

// request拦截器
service.interceptors.request.use(
    config => {
        config.headers["Content-Type"] = ' application/json;charset=UTF-8';
        if (store.getters.adminId && store.getters.token) {
            config.headers["X-Adminid"] = store.getters.adminId;
            config.headers["X-Token"] = store.getters.token;
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// respone拦截器
service.interceptors.response.use(
    response => {
        const data = response.data;
        if (data.code) {
            if (data.code === 2) {
                store.dispatch("loginOut").then(() => {
                    Message.error("登录信息过期,请重新登录");
                    window.location.replace("/login");
                });
            }
        }
        return data;
    },
    error => {
        Message({
            message: error.message,
            type: "error",
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export function uploadreportApi(params) {
  return new Promise((resolve, reject) => {
    axios.post(BSL + '/otherorderCommodity/impExcel', params, {
      headers: {
        'token': store.getters.token,
        'Content-Type': 'multipart/form-data'
      }
    }).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    ).catch(error => {
      console.log('catch', error)
      reject(error)
    })
  })
}

export default service;
